import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RequestResponse } from '../model/dto/RequestResponse';
import { StoreReportDto } from '../model/dto/StoreReportDto';
import { StoreDetailReportDto } from '../model/dto/StoreDetailReportDto';
import { StoreReportChecklistDto } from '../model/dto/StoreReportChecklistDto';

@Injectable()
export class ActivityStoreFacade {
    private _urlBase: string;
    private _httpClient: HttpClient;

    constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
        this._urlBase = baseUrl;
        this._httpClient = http;
    }

    GetSummary(catDetTaskTypeId: number, language: number): Observable<any> {
        return this._httpClient.get<any>(this._urlBase
             + 'api/ActivityStore/Summary?catDetTaskTypeId=' + catDetTaskTypeId + '&language=' + language);
    }

    GetReport(activityCode: string, requiredDate: string, language: number, organizations: string = ''): Observable<any> {
        return this._httpClient.get<any>(
            this._urlBase
            + 'api/ActivityStore/Report?activityCode=' + activityCode + '&requiredDate=' + requiredDate + '&language=' + language + '&organizationId=' + organizations);
    }

    GetReportPdf(activStoreId: number, languageSpanish: boolean): Observable<any> {
        return this._httpClient.get<any>(this._urlBase
             + 'api/ActivityStore/ReportPdf?activStoreId=' + activStoreId + '&languageSpanish=' + languageSpanish);
    }

    GetDetail(activStoreId: number): Observable<any> {
        return this._httpClient.get<any>(this._urlBase + 'api/ActivityStoreInstruction/Detail?activStoreId=' + activStoreId);
    }

    GetPriceSummary(activStoreId: number): Observable<any> {
        return this._httpClient.get<any>(this._urlBase + 'api/ActivityStorePrice/Summary?activStoreId=' + activStoreId);
    }

    GetPriceAdvance(activStoreId: number, sectionId: number, genderId: number): Observable<any> {
        return this._httpClient.get<any>(
            this._urlBase +
            'api/ActivityStorePrice/Advance?activStoreId=' + activStoreId + '&sectionId=' + sectionId + '&genderId=' + genderId);
    }

    GetStoresReport(startDate: any, endDate: any): Observable<RequestResponse<StoreReportDto[]>> {
        return this._httpClient.get<RequestResponse<StoreReportDto[]>>(
          this._urlBase + 'api/ActivityStore/ReportStore?startDate=' + startDate + '&endDate=' + endDate);
    }

    GetDetailReport(storeId: number, taskTypeId: number, startDate: any, endDate: any ):
     Observable<RequestResponse<StoreDetailReportDto[]>> {
        return this._httpClient.get<RequestResponse<StoreDetailReportDto[]>>(
            this._urlBase + 'api/ActivityStore/ReportStoreByTaskType?storeId=' + storeId
            + '&taskTypeId=' + taskTypeId + '&startDate=' + startDate + '&endDate=' + endDate);
    }

    GetStoresReportCheckList(startDate: any, endDate: any): Observable<RequestResponse<StoreReportChecklistDto[]>> {
        return this._httpClient.get<RequestResponse<StoreReportChecklistDto[]>>(
          this._urlBase + 'api/ActivityStore/ReportStoreCheckList?startDate=' + startDate + '&endDate=' + endDate);
    }
}
